import React, { useEffect, useState } from "react";
import TableHeading from "../../components/common/TableHeading";
import Inputwithlable from "../../components/common/inputwithlable";
import {
  GREYEDIT_ICON,
  RIGHTARROW_ICON,
  BLUEEDIT_ICON,
  BLUESTATUS_ICON,
  GREYSTATUS_ICON,
  BLUEPLUSICON_ICON,
  GREYPLUSICON_ICON,
  GREYEYE_ICONIMG,
  BLUEEYE_ICONIMG,
} from "../../../utills/image-constant";
import Loginbtn from "../../components/common/loginbtn";
import { adminAddRole, getAllModule } from "../../../services/api-services";
import { toastEmitter } from "../../../utills/utilities";
import { API_RESPONSE } from "../../../utills/app-constant";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes/url-constant";
import {
  checkValidation,
  ErrorMessage,
  ErrorMsg,
} from "../../../utills/error-message-constant";
import { alphaletter } from "../../../utills/form-regex";

const AddRole = () => {
  const location = useLocation();
  const [formError, setFormError] = useState();
  const [roleName, setRoleName] = useState("");
  const [rolebtnLoader, setRolebtnLoader] = useState(false);
  const [globalSelectAll, setGlobalSelectAll] = useState(false);
  const navigate = useNavigate();

  let roleType = location.state?.pageType;
  let roleData = location.state?.Data;

  const [addRolePayload, setAddRolePayload] = useState({
    id: roleData ? roleData?.id : "",
    roleName: roleData ? roleData?.roleName : "",
    roleDescription: roleData ? roleData?.roleDescription : "",
    moduleRequestList: roleData ? roleData?.roleModuleMappingResponseList : "",
    allModuleSelected: false,
  });

  const [modulePermission, setModulePermission] = useState(
    addRolePayload?.moduleRequestList
  );

  const getAdminPermissionModule = async () => {
    try {
      const response = await getAllModule();
      if (response?.data?.responseCode === 200) {
        setModulePermission(response?.data?.responseBody);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

  useEffect(() => {
    if (roleType === undefined) {
      getAdminPermissionModule();
    }
  }, []);

  // Handle role name input change
  const handleChangeRole = (e) => {
    const { value, name } = e.target;
    if (name === "roleName") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.RoleName,
        alphaletter,
        formError,
        setFormError
      );
    }
    setRoleName(value);
    setAddRolePayload((prev) => ({ ...prev, roleName: value }));
  };

  // Handle permission change
  const handlePermissionChange = (moduleIndex, permissionType, value) => {
    const newPermission = modulePermission.map((existingPermission, index) => {
      if (moduleIndex === index) {
        return { ...existingPermission, [permissionType]: value ? 1 : 0 };
      } else {
        return existingPermission;
      }
    });

    setModulePermission(newPermission);
    setAddRolePayload((prevPayload) => ({
      ...prevPayload,
      moduleRequestList: newPermission,
    }));

    // Update global checkbox based on all modules
    const allSelected = newPermission.every((m) =>
      ["addAction", "updateAction", "viewAction", "moduleAction"].every(
        (key) => m[key] === 1
      )
    );
    setGlobalSelectAll(allSelected);
  };

  // Toggle all permissions per module
  const handleAllActionSelect = (moduleIndex, value) => {
    const newPermission = modulePermission?.map((existingPermission, index) => {
      if (moduleIndex === index && value) {
        return {
          ...existingPermission,
          addAction: 1,
          updateAction: 1,
          viewAction: 1,
          moduleAction: 1,
        };
      } else if (moduleIndex === index && !value) {
        return {
          ...existingPermission,
          addAction: 0,
          updateAction: 0,
          viewAction: 0,
          moduleAction: 0,
        };
      } else {
        return { ...existingPermission };
      }
    });

    setModulePermission(newPermission);
    setAddRolePayload((prevPayload) => ({
      ...prevPayload,
      moduleRequestList: newPermission,
    }));

    // If all modules are fully selected, check global select
    const allSelected = newPermission.every((m) =>
      ["addAction", "updateAction", "viewAction", "moduleAction"].every(
        (key) => m[key] === 1
      )
    );
    setGlobalSelectAll(allSelected);
  };

  // Handle global select all (header)
  const handleGlobalSelectAll = (value) => {
    setGlobalSelectAll(value);
    const updatedPermissions = modulePermission.map((m) => ({
      ...m,
      addAction: value ? 1 : 0,
      updateAction: value ? 1 : 0,
      viewAction: value ? 1 : 0,
      moduleAction: value ? 1 : 0,
    }));

    setModulePermission(updatedPermissions);
    setAddRolePayload((prev) => ({
      ...prev,
      moduleRequestList: updatedPermissions,
    }));
  };

  // Add or update role
  const handleAddRole = async () => {
    if (
      addRolePayload?.roleName === "" ||
      addRolePayload?.roleName === undefined
    ) {
      toastEmitter("error", "Role Name Is Required!");
      return;
    } else if (
      addRolePayload.moduleRequestList === "" ||
      addRolePayload?.moduleRequestList === undefined
    ) {
      toastEmitter("error", "Please add atleast one permission");
      return;
    }
    try {
      setRolebtnLoader(true);
      const response = await adminAddRole(addRolePayload);
      setRolebtnLoader(false);
      if (response?.data?.responseCode !== 200) {
        toastEmitter("error", response?.data?.message);
      } else {
        toastEmitter("success", response?.data?.message);
        navigate(ROUTES.ADMINROLE);
        if (roleType === "Edit") {
          window.location.reload();
        }
      }
    } catch (err) {
      setRolebtnLoader(false);
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

  const handleNavigateBack = () => {
    navigate(ROUTES.ADMINROLE);
  };

  return (
    <>
      <div className="modal_datatable">
        <TableHeading
          className="cursor-pointer"
          firstData="Team Management"
          secondData="Team Role Access"
          icon={RIGHTARROW_ICON}
          iconshow={true}
          thirdData={roleType === "Edit" ? "Update Role" : "Add Role"}
          onFirstDataClick={handleNavigateBack}
        />
        <div className="container-fluid">
          <div className="caspera_admin_datatable mb-3">
            <div className="row">
              <div className="col-md-5 mb-2 px-4">
                <Inputwithlable
                  placeHolder="Enter Role Name"
                  name="roleName"
                  type="text"
                  labelName="Enter Role Name"
                  lableclassName="addInput-label"
                  className="form-control addInputText-lable"
                  placeholder="Enter Role Name"
                  value={addRolePayload?.roleName}
                  showastrict={true}
                  handleChange={handleChangeRole}
                  disable={roleType === "view"}
                  error={formError?.roleName}
                  maxlng={64}
                />
              </div>
              <div className="ms-3">
                <ErrorMsg error={formError?.roleName} />
              </div>
            </div>

            <div className="caspera_add_role">
              <div className="container-fluid mt-3">
                <table className="table permission-table">
                  <thead>
                    <tr>
                      <th scope="col">
                        <input
                          type="checkbox"
                          checked={globalSelectAll}
                          disabled={roleType === "view"}
                          onChange={(e) =>
                            handleGlobalSelectAll(e.target.checked)
                          }
                        />{" "}
                        Select All
                      </th>
                      <th scope="col">Permissions</th>
                      <th scope="col">Add</th>
                      <th scope="col">View</th>
                      <th scope="col">Edit</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {modulePermission &&
                      modulePermission?.map((permissiondata, index) => {
                        const hitSelectAll = {
                          addAction: permissiondata?.addAction,
                          viewAction: permissiondata?.viewAction,
                          updateAction: permissiondata?.updateAction,
                          moduleAction: permissiondata?.moduleAction,
                        };
                        const checkSelect = Object.values(hitSelectAll).every(
                          (value) => value === 1
                        );

                        return (
                          <tr key={index}>
                            <td>
                              <input
                                id={permissiondata.moduleName + index}
                                type="checkbox"
                                checked={
                                  permissiondata.moduleName === "Dashboard" &&
                                    permissiondata?.viewAction === 1
                                    ? true
                                    : checkSelect
                                }
                                disabled={roleType === "view"}
                                onChange={(e) =>
                                  handleAllActionSelect(
                                    index,
                                    e.target.checked
                                  )
                                }
                              />
                            </td>
                            <td>{permissiondata.moduleName}</td>
                            <td>
                              {permissiondata.moduleName !== "Dashboard" && (
                                <label>
                                  <input
                                    disabled={roleType === "view"}
                                    id={permissiondata.moduleName + index}
                                    type="checkbox"
                                    className="form-check-input d-none"
                                    checked={permissiondata.addAction === 1}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        index,
                                        "addAction",
                                        e.target.checked
                                      )
                                    }
                                  />
                                  <img
                                    src={
                                      permissiondata.addAction === 1
                                        ? BLUEPLUSICON_ICON
                                        : GREYPLUSICON_ICON
                                    }
                                    alt="add-action"
                                    className="roleicons"
                                    style={{
                                      opacity: roleType === "view" ? 0.5 : 1,
                                    }}
                                  />
                                </label>
                              )}
                            </td>
                            <td>
                              <label>
                                <input
                                  disabled={roleType === "view"}
                                  id={permissiondata.moduleName + index}
                                  className="form-check-input d-none"
                                  type="checkbox"
                                  checked={permissiondata.viewAction === 1}
                                  onChange={(e) =>
                                    handlePermissionChange(
                                      index,
                                      "viewAction",
                                      e.target.checked
                                    )
                                  }
                                />
                                <img
                                  src={
                                    permissiondata.viewAction === 1
                                      ? BLUEEYE_ICONIMG
                                      : GREYEYE_ICONIMG
                                  }
                                  alt="view-action"
                                  className="roleicons"
                                  style={{
                                    opacity: roleType === "view" ? 0.5 : 1,
                                  }}
                                />
                              </label>
                            </td>
                            <td>
                              {permissiondata.moduleName !== "Dashboard" && (
                                <label>
                                  <input
                                    disabled={roleType === "view"}
                                    id={permissiondata.moduleName + index}
                                    className="form-check-input d-none"
                                    type="checkbox"
                                    checked={
                                      permissiondata.updateAction === 1
                                    }
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        index,
                                        "updateAction",
                                        e.target.checked
                                      )
                                    }
                                  />
                                  <img
                                    src={
                                      permissiondata.updateAction === 1
                                        ? BLUEEDIT_ICON
                                        : GREYEDIT_ICON
                                    }
                                    alt="edit-action"
                                    className="roleicons"
                                    style={{
                                      opacity: roleType === "view" ? 0.5 : 1,
                                    }}
                                  />
                                </label>
                              )}
                            </td>
                            <td>
                              {permissiondata.moduleName !== "Dashboard" && (
                                <label>
                                  <input
                                    disabled={roleType === "view"}
                                    id={permissiondata.moduleName + index}
                                    type="checkbox"
                                    className="form-check-input d-none"
                                    checked={permissiondata.moduleAction === 1}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        index,
                                        "moduleAction",
                                        e.target.checked
                                      )
                                    }
                                  />
                                  <img
                                    src={
                                      permissiondata.moduleAction === 1
                                        ? BLUESTATUS_ICON
                                        : GREYSTATUS_ICON
                                    }
                                    alt="status-action"
                                    className="roleicons"
                                    style={{
                                      opacity: roleType === "view" ? 0.5 : 1,
                                    }}
                                  />
                                </label>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>

            {roleType === "view" ? (
              ""
            ) : (
              <div className="pt-4 d-flex justify-content-center">
                <Loginbtn
                  className="addbtn w-100 px-4 py-2"
                  handleClick={handleAddRole}
                  type="submit"
                  btnName={roleType === "Edit" ? "Update" : "Add Permission"}
                  loader={rolebtnLoader}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddRole;
